import { useTranslation } from 'react-i18next';
import { SemPermissao, Vazio } from '../componentes/estados';
import { LimiteErro } from '../componentes/limite-erro';
import { useSessao } from '../nucleo/sessao';
import { modulosWeb, paginasDaCasca, type PaginaCascaWeb } from '../nucleo/modulos-web';

/**
 * CRM no novo desenho (Fase 2): a página da casca de um módulo (`paginasCasca`), montada em `/<caminho>/*`. Sem o módulo
 * instalado, "não encontrada"; sem a permissão, "sem permissão". A tela cuida das próprias sub-rotas.
 */
export function PaginaCasca({ slug, pagina }: { slug: string; pagina: PaginaCascaWeb }) {
  const { t } = useTranslation();
  const s = useSessao();
  if (!s.instalado(slug)) return <Vazio titulo={t('estados.naoEncontrado')} texto="" />;
  if (!paginasDaCasca(s).some((x) => x.slug === slug && x.pagina.chave === pagina.chave)) return <SemPermissao />;
  const Tela = pagina.componente;
  return (
    <LimiteErro key={pagina.caminho}>
      <Tela />
    </LimiteErro>
  );
}

/** Todas as páginas da casca declaradas (as rotas existem sempre; o guarda decide na hora). */
export const PAGINAS_CASCA = modulosWeb.flatMap((m) => (m.paginasCasca ?? []).map((pagina) => ({ slug: m.slug, pagina })));
